import * as React from 'react'

import { createLucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

const HEX_D =
  'M12.75 2.43296C12.2859 2.16501 11.7141 2.16501 11.25 2.43296L9.49998 3.44332V8.87726C10.1848 8.3283 11.054 7.99994 12 7.99994L20.6602 7.99994V7.86597C20.6602 7.33007 20.3743 6.83488 19.9102 6.56693L12.75 2.43296ZM20.6602 9.49994L15.1227 9.49994C15.6716 10.1847 16 11.054 16 11.9999V19.6905L19.9102 17.433C20.3743 17.165 20.6602 16.6698 20.6602 16.1339V9.49994ZM14.5 20.5566V15.1226C13.8152 15.6716 12.9459 15.9999 12 15.9999H3.33972V16.1339C3.33972 16.6698 3.62562 17.165 4.08972 17.433L11.25 21.5669C11.7141 21.8349 12.2859 21.8349 12.75 21.5669L14.5 20.5566ZM3.33972 14.4999H8.87729C8.32834 13.8151 7.99998 12.9459 7.99998 11.9999V4.30934L4.08972 6.56693C3.62562 6.83488 3.33972 7.33007 3.33972 7.86597V14.4999Z'
const DOT_D =
  'M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z'

const mk = (hex: string, dot: string) =>
  createLucideIcon('StruxHubSpinner', [
    [
      'path',
      {
        key: 'hex',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: HEX_D,
        fill: hex,
        stroke: 'none',
      },
    ],
    ['path', { key: 'dot', d: DOT_D, fill: dot, stroke: 'none' }],
  ])

const MARKS = {
  dark: mk('#1A1D1E', '#EA9600'),
  white: mk('#FFFFFF', '#EA9600'),
  muted: mk('#5E6163', '#9EA0A2'),
}

const SIZE = { xs: 16, sm: 20, md: 26, lg: 50 }

export type SpinnerVariant = keyof typeof MARKS
export type SpinnerSize = keyof typeof SIZE

interface IProps {
  size?: SpinnerSize
  variant?: SpinnerVariant
  className?: string
}

export default function Spinner({
  size = 'md',
  variant = 'dark',
  className,
}: IProps) {
  const Mark = MARKS[variant]
  return (
    <Mark
      role="status"
      aria-label="Loading"
      size={SIZE[size]}
      className={cn('tw:inline-block tw:animate-spin', className)}
    />
  )
}
